import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AlertService, IAlertType, OffersStoreService } from "../../../../_shared/services";
import { Offers, StatusButtons } from "../../../../_shared/interfaces";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";

import * as XLSX from "xlsx";
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-offers-overview',
  standalone: true,
  imports: [
    ClrIconModule,
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe
  ],
  templateUrl: './offers-overview.component.html',
  styleUrl: './offers-overview.component.sass'
})
export class OffersOverviewComponent implements OnInit, OnChanges {
  offers: Offers[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';

  @Input() status!: string;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'sent', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'rejected', display: 'Entgangen', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'confirmed', display: 'Akzeptiert', label: 'alert-success', icon: 'check-circle'}
  ];

  constructor(
    private offss: OffersStoreService,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.loadList(this.status);
  }

  loadList(status: string) {
    this.offss.getOffers('0', 0, status).subscribe({
      next: data => {
        this.offers = data?.object ?? [];
        if (this.offers.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Angebote gefunden.',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(offerstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === offerstatus)
  };

  getCellStatus(offerstatus: string) {
    const statusline = this.findButtonStatus(offerstatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(offerstatus: string) {
    return "alert " + this.getCellStatus(offerstatus).statusLabel + " alert-sm";
  }

  exportToExcel(data: any): void {
    // Dokumentation: https://docs.sheetjs.com
    let offers = data;
    offers.map((obj: Offers) => {
      let offer = obj as Partial<Offers>; // Type Assertion
      delete offer['status'];
      delete offer['employee_phm'];
      delete offer['employee_leader'];
      delete offer['cond_delivery'];
      delete offer['cond_payment'];
      delete offer['cond_offer'];
      delete offer['person_delivery'];
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(offers);

    const book: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, worksheet, 'Offers In Arbeit');

    XLSX.writeFile(book, 'Offers-Übersicht.xlsx');
  }
}
